import AnalyticsService from './analytics/analytics_service';

if (!window.BPFTracking) {
  const service = new AnalyticsService();
  service.initialize();
}